import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field } from "redux-form";
import { renderFieldText } from "@basecomponent";
import LocaleStrings from "@language";

const CompanyDetails = (props) => {
  return (
    <>
      <div className="rounded-xl border border-default">
        <div className="rounded-t-xl border-b border-default bg-default px-6 py-4">
          <div className="custom-text-primary-md-medium">
            {LocaleStrings.kCompanyInformationText}
            {<span className="label-mandatory">*</span>}
          </div>
          <div className="custom-text-secondary-sm-medium">
            {LocaleStrings.kCompanyInformationSubtitleText}
          </div>
        </div>
        <dl className="base-form px-6 py-4">
          <Field
            name={"companyinfo"}
            label={LocaleStrings.kCompanyNameText}
            type={"text"}
            component={renderFieldText}
            mandatory={true}
          />
        </dl>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return { eventData: state.eventData };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CompanyDetails);
